export default "__VITE_ASSET__OCJQ8rGr__"